export default __webpack_public_path__ + "static/media/bin_yellow.a8e527c4.svg";